'use client';

/**
 * GoogleReviewsFinalCTA — closes the page with the standard V3 final
 * CTA (cyan halo, two-clause headline, primary + secondary CTAs).
 */

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const GoogleReviewsFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('GoogleReviews/FinalCTA/aria_label')}
      copy={{
        headlineA: t('GoogleReviews/FinalCTA/title1'),
        headlineB: t('GoogleReviews/FinalCTA/title2'),
        subhead: t('GoogleReviews/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('GoogleReviews/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('GoogleReviews/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default GoogleReviewsFinalCTA;
